export default ({ request }) => ({
  expoMeetingTimelineApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/timeline',
      method: 'post',
      data,
    })
  },
  expoMeetingDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/detail',
      method: 'post',
      data,
    })
  },
  expoMeetingSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/save',
      method: 'post',
      data,
    })
  },
  expoMeetingCancelApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/cancel',
      method: 'post',
      data,
    })
  },
  expoMeetingCheckAuthApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/checkAuth',
      method: 'post',
      data,
    })
  },
  expoMeetingConfirmApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/confirm',
      method: 'post',
      data,
    })
  },
  expoMeetingDocListApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/doc/list',
      method: 'post',
      data,
    })
  },
  expoMeetingDocUploadApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/doc/upload',
      method: 'post',
      data,
    })
  },
  expoMeetingDocDelApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/doc/del',
      method: 'post',
      data,
    })
  },
  expoMeetingSelectionListApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/selection/list',
      method: 'post',
      data,
    })
  },
  expoMeetingSelectionDelApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/selection/del',
      method: 'post',
      data,
    })
  },
  expoMeetingSelectionDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/selection/detail',
      method: 'post',
      data,
    })
  },
  expoMeetingSelectionUpdateRemarkApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/selection/updateRemark',
      method: 'post',
      data,
    })
  },
  expoMeetingSelectionBindSamplesApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/selection/bind/samples',
      method: 'post',
      data,
    })
  },
  expoMeetingCommentsListApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/comments/list',
      method: 'post',
      data,
    })
  },
  expoMeetingCommentsSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/comments/save',
      method: 'post',
      data,
    })
  },
  expoSampleMeetingListApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/sample/meeting/list',
      method: 'post',
      data,
    })
  },
  expoSampleMeetingAddApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/sample/meeting/add',
      method: 'post',
      data,
    })
  },
  expoSampleMeetingDelApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/sample/meeting/del',
      method: 'post',
      data,
    })
  },
  expoTskInfoSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/save',
      method: 'post',
      data,
    })
  },
  expoTskInfoListApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/list',
      method: 'post',
      data,
    })
  },
  expoTskInfoDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/detail',
      method: 'post',
      data,
    })
  },
  expoTskInfoDocListApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/doc/list',
      method: 'post',
      data,
    })
  },
  expoTskInfoDocUploadApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/doc/upload',
      method: 'post',
      data,
    })
  },
  expoTskInfoDocDelApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/doc/del',
      method: 'post',
      data,
    })
  },
  expoTskInfoDocAddApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/doc/add',
      method: 'post',
      data,
    })
  },
  expoMeetingDocPageListApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/doc/page/list',
      method: 'post',
      data,
    })
  },
  expoMeetingEndApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/end',
      method: 'post',
      data,
    })
  },
  expoTskInfoMeetingSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/meeting/save',
      method: 'post',
      data,
    })
  },
  expoTskInfoSelectionTodoListApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/selection/todo/list',
      method: 'post',
      data,
    })
  },
  expoTskInfoMeetingDispatchApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/meeting/dispatch',
      method: 'post',
      data,
    })
  },
  expoTskInfoMeetingSelectionChooseFabricApi(data = {}) {
    return request({
      url: '/digitalCenter/expo/meeting/selection/choose/fabric',
      method: 'post',
      data,
    })
  },
})
